import { render, staticRenderFns } from "./CustomOptions.vue?vue&type=template&id=36abd5bc&"
import script from "./CustomOptions.vue?vue&type=script&lang=js&"
export * from "./CustomOptions.vue?vue&type=script&lang=js&"
import style0 from "./CustomOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports